module.exports = __webpack_public_path__ + "img/zt4-1.999b46c.png";